import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.table.row.text,
  },
  head: {
    backgroundColor: 'inherit',
    paddingTop: '4px',
    paddingBottom: '4px',
    borderBottom: 'none',
    fontWeight: 700,
  },
  '@global': {
    'th:first-of-type': {
      paddingLeft: '16px',
    },
    'th:last-of-type': {
      paddingRight: 0,
    },
  },
}));

export default useStyles;
